// -----------------------------------------------------------------------------
// MODULE REGISTRY — the list of plug-in modules the shell knows about.
// To add a module (e.g. 'progress'):
//   1. SQL: insert into app.modules + role_module_access rows; add <module>_… API functions.
//   2. Add an entry here (id MUST equal app.modules.id) and its routes in core/router.ts.
//   3. Add its pages under src/modules/<id>/ and wire them in app/App.tsx.
// -----------------------------------------------------------------------------
import type { Route } from "../core/router";

export interface ModuleDef {
  id: string;                          // = app.modules.id
  entry: (code: string) => Route;      // where the sidebar link goes inside a project
}

export const MODULES: ModuleDef[] = [
  { id: "issues", entry: (code) => ({ name: "issues", code }) },
  // { id: "progress", entry: (code) => ({ name: "progress", code }) },   // placeholder module — not built yet
];

/** Sidebar link for a module, or undefined if the module has no pages yet. */
export const moduleEntryRoute = (id: string, code: string): Route | undefined =>
  MODULES.find((m) => m.id === id)?.entry(code);
